import { render, staticRenderFns } from "./my_orders.vue?vue&type=template&id=adc4ddae&scoped=true"
import script from "./my_orders.vue?vue&type=script&lang=js"
export * from "./my_orders.vue?vue&type=script&lang=js"
import style0 from "./my_orders.vue?vue&type=style&index=0&id=adc4ddae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc4ddae",
  null
  
)

export default component.exports